import { DESIGNED_FOR } from '@/config/marketingContent';

export default function DesignedFor() {
  return (
    <section className="py-16 md:py-20 border-t border-[#2a2a2a]">
      <div className="max-w-6xl mx-auto px-4">
        <p className="ni-label mb-3">Designed for</p>
        <h2 className="text-2xl md:text-3xl font-sans font-bold text-white mb-10">
          Institutional development workflows
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {DESIGNED_FOR.map((persona) => (
            <div key={persona.title} className="ni-panel p-5 flex flex-col">
              <h3 className="text-lg font-sans font-semibold text-white mb-2">{persona.title}</h3>
              <p className="text-sm text-white/50 font-sans leading-relaxed flex-1">{persona.body}</p>
              <div className="flex flex-wrap gap-1.5 mt-4">
                {persona.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-[9px] font-mono uppercase tracking-wider border border-[#3a3a3a] px-2 py-0.5 text-white/40"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
